// extracted by mini-css-extract-plugin
export default {"wrapper":"Logo_wrapper__pPuWc","img":"Logo_img__TffwS"};